<template>
  <div class="slidecontainer">

    <input type="range"
      v-model="val"
      :min="cheapest"
      :max="priciest"
      step="1"
      class="slider" id="myRange"
      />

      <ActionButton
        title="Tilfældig øl under kr:"
        :value="parseInt(val)"
        v-on:click-action="getRandomBeer">
      </ActionButton>


  </div>
</template>

<script>
import ActionButton from './ActionButton.vue';

  export default {
    name: 'Slider',
    components: {
      ActionButton
    },
    props: {
      beers: Array,
      user: Object
    },
    data() {
      return {
        val: 272
      }
    },
    computed: {
      cheapest: function(){
        let sorted = Array.from(this.beers);
        if(sorted.length > 0){
          sorted.sort((a, b) => a.price - b.price);
          return sorted[0].price;
        }return 0;
      },
      priciest: function(){
        let sorted = Array.from(this.beers);
        if(sorted.length > 0){
          sorted.sort((a, b) => b.price - a.price);
          return sorted[0].price;
        }return 300;
      }
    },
    methods: {
      getRandomBeer(){
        let nottrieddbeers = this.beers.filter(beer => {
          let beerids = this.user.drinkedBeers.map(beer => beer.id);
          return !beerids.includes(beer.id);
        });
        nottrieddbeers = nottrieddbeers.filter(beer => {
          return beer.price <= this.val;
        });
        let randomIndex = Math.floor(Math.random() * nottrieddbeers.length);
        this.$router.push({name: 'øl', params: {beer: nottrieddbeers[randomIndex]}});
      }
    }
  };


</script>

<style scoped>

.slidecontainer {
  width: 80%; /* Width of the outside container */
  margin: auto;
}

/* The slider itself */
.slider {
  -webkit-appearance: none;  /* Override default CSS styles */
  appearance: none;
  width: 100%; /* Full-width */
  height: 30px; /* Specified height */
  background: #ccc; /* Grey background */
  outline: none; /* Remove outline */
  border-radius: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
}

/* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
.slider::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
  appearance: none;
  width: 85px;
  height: 40px;
  background: var(--primaryColor);
  cursor: pointer;
  border-radius: 5px;
}



</style>
